<template>
  <div class="global-skeleton ahc-main__content">
    <!-- Breadcrumb -->
    <div class="global-skeleton__breadcrumb">
      <span class="global-skeleton__anim-text" />
    </div>
    <!-- Title -->
    <div class="global-skeleton__title">
      <span class="global-skeleton__anim-text" />
    </div>
    <!-- Subtitle -->
    <div class="global-skeleton__subtitle">
      <span class="global-skeleton__anim-text" />
    </div>
    <!-- Cards -->
    <div class="global-skeleton__cards">
      <div class="global-skeleton__card">
        <span class="global-skeleton__anim-text" />
      </div>
      <div class="global-skeleton__card">
        <span class="global-skeleton__anim-text" />
      </div>
    </div>
    <!-- Section -->
    <div class="global-skeleton__section">
      <div class="global-skeleton__section-title">
        <span class="global-skeleton__anim-text" />
        <span class="global-skeleton__anim-text" />
      </div>
      <div class="global-skeleton__section-content">
        <!-- List -->
        <div class="global-skeleton__list">
          <div class="global-skeleton__list-item">
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
          </div>
          <div class="global-skeleton__list-item">
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
          </div>
          <div class="global-skeleton__list-item">
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
            <span class="global-skeleton__anim-text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.global-skeleton {
  position: relative;
  background-color: ads.$ads-surface-container-mid;

  div {
    position: relative;
  }

  span {
    display: block;
  }

  &__breadcrumb {
    padding: ads.$ads-spacing-scale-md 0 ads.$ads-spacing-scale-lg;

    @include ads-sass.ads-breakpoint('large+') {
      display: none;
    }

    span {
      max-width: 100px;
      height: 20px;
    }
  }

  &__title {
    span {
      margin-bottom: ads.$ads-spacing-scale-2xl;
      height: 36px;
      width: 80%;

      @include ads-sass.ads-breakpoint('large+') {
        width: 30%;
      }
    }
  }

  &__subtitle {
    span {
      margin-bottom: ads.$ads-spacing-scale-lg;
      height: 24px;
      width: 50%;

      @include ads-sass.ads-breakpoint('large+') {
        width: 15%;
      }
    }
  }

  &__cards {
    display: flex;
    flex-direction: column;
    gap: ads.$ads-spacing-scale-2xl;

    @include ads-sass.ads-breakpoint('large+') {
      flex-direction: row;
    }
  }

  &__card {
    width: 100%;

    span {
      height: 200px;
      margin-bottom: ads.$ads-spacing-scale-lg;
    }
  }

  &__section {
    border-top: 1px solid ads.$ads-outline-low;
    margin-bottom: ads.$ads-spacing-scale-6xl;
    padding-top: ads.$ads-spacing-scale-lg;
    align-items: flex-start;
    justify-content: flex-start;
    display: block;
    width: 100%;
    gap: ads.$ads-spacing-scale-2xl;

    @include ads-sass.ads-breakpoint('large+') {
      display: flex;
    }
  }

  &__section-title {
    width: 100%;

    @include ads-sass.ads-breakpoint('large+') {
      width: 60%;
    }

    span {
      &:nth-child(1) {
        width: 100%;
        height: 60px;
        margin-bottom: ads.$ads-spacing-scale-md;
      }

      &:nth-child(2) {
        width: 100%;
        height: 265px;
        margin-bottom: ads.$ads-spacing-scale-2xl;
      }
    }
  }

  &__section-content {
    width: 100%;
    padding-left: 0;

    @include ads-sass.ads-breakpoint('large+') {
      width: 60%;
    }
  }

  &__list {
    position: relative;
    border: 1px solid ads.$ads-outline-low;
    border-radius: ads.$ads-border-radius-element-lg;
    display: block;
    width: 100%;

    &-item {
      position: relative;
      padding: 25px 25px 31px 105px;
      border-bottom: 1px solid ads.$ads-outline-low;

      span {
        &:nth-child(1) {
          position: absolute;
          left: 25px;
          top: 25px;
          width: 56px;
          height: 56px;
        }

        &:nth-child(2) {
          width: 70%;
          max-width: 211px;
          height: 22px;
          margin-bottom: ads.$ads-spacing-scale-md;
        }

        &:nth-child(3) {
          width: 55%;
          max-width: 160px;
          height: 22px;
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  &__anim-text {
    will-change: transform;
    background: linear-gradient(
      75deg,
      ads.$ads-outline-low 15%,
      #c0bfc4 25%,
      ads.$ads-outline-low 45%
    );
    background-size: 800px 400px;
  }

  &__anim-text {
    animation: placeHolderShimmer 4.5s linear infinite forwards;
  }
}

@keyframes placeHolderShimmer {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-position: -800px 0;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-position: 800px 0;
  }
}
</style>
